import React from 'react';
import { useLocation } from 'react-router-dom';
import SignInPanel from '@/js/components/SignInPanel';
import leftHalfImage from '@/js/images/signup-select.webp';

const SigninPage = () => {
  const location = useLocation();
  const signUpEmail = location?.state?.email ? location.state.email : '';
  return (
    <div className="splitinhalf flex justify-center min-h-[calc(100vh-70px)] ">
      {/* ---- First Half ---- */}
      <div className="half-1 lg:flex w-1/2 items-center justify-center hidden">
        <div className="flex mr-28 flex-col items-end justify-end transform transition-transform duration-300 lg:scale-90 md:scale-75">
          {/* ----- Left Image ----- */}
          <img
            src={leftHalfImage}
            alt="signup-hero"
            width={640}
            className="transform transition-transform duration-300"
          />
          {/* ----- Box UI ----- */}
          <div
            className="piece-box w-[350px] h-[124px] fixed rounded-3xl text-[15px] p-5 text-gray-600 text-center"
            style={{
              background:
                'linear-gradient(97.27deg, rgba(118, 54, 217, 0.09) 5.17%, rgba(250, 250, 250, 0.6) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.11), rgba(0, 0, 0, 0.12))',
              // Scale down width and height while keeping the box in the same fixed position
              // transform: 'scale(0.9)', // Apply the scale directly to the box
              transformOrigin: 'top left', // Ensures the box scales down from the top right corner
            }}
          >
            Find the perfect manufacturer, get quotes, and manage purchase
            orders effortlessly. Bring your medical device to market faster!
          </div>
        </div>
      </div>

      {/* ---- Second Half ---- */}
      <div className="half-2 w-full xl:w-1/2 flex bg-gray-100 items-center overflow-y-auto xl:justify-center justify-center">
        <div className="form-box flex w-5/6 flex-col justify-center items-center text-center">
          <div className="flex justify-center">
            <img
              src="./blackLogo.svg"
              className="w-[67px] "
              alt="MakerSharks-logo"
            />
            <h1 className="items-center flex ml-3 font-roboto text-2xl lg:text-3xl font-semibold">
              MakerSharks
            </h1>
          </div>
          <p className="mt-4 text-base lg:text-lg text-gray-500 text-center">
            Become a part of our network and start connecting
          </p>
          <p className="text-base lg:text-lg mb-5 lg:mb-8 text-gray-500 text-center">
            with others in your industry.
          </p>
          <SignInPanel signUpEmail={signUpEmail} />
        </div>
      </div>
    </div>
  );
};

export default SigninPage;
//
// const LoginPage = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       // Assuming you have an API call to login
//       const response = await loginAPI({ email, password });

//       // Dispatch login action with user data
//       dispatch(loginUserAction({
//         ...response.user,
//         x_auth_key: response.token,
//         isVerified: response.user.isVerified
//       }));

//       // Redirect based on user role
//       navigate(`/${response.user.route || 'dashboard'}`);
//     } catch (error) {
//       // Handle login error
//       console.error('Login failed', error);
//     }
//   };

//   return (
//     <form onSubmit={handleLogin}>
//       {/* Login form fields */}
//     </form>
//   );
// };
